import React, { Component } from "react";
import { mensajeExito } from "../../../generico/MensajeSistemaToast"
import DataTable from 'react-data-table-component';
import history from "../../login/history"
import DatosSocio from "../../../generico/DatosSocio"
import ConfigService from "../../../../services/configuracion/ConfigService";
import Popup from "react-popup";
import { mayusculaPrimeraLetra } from "../../../generico/utils/FormatoInput";

export default class ModificarPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
  })

  componentDidMount() {
  
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });

  VolverSubsidios = () => {
    history.push(ConfigService.getPathByName("solicitudSubsidios")?.url);
    window.location.reload();
  }

  render() {
    if( this.props.currentStep !== 2)
    return(<span />)
    if(this.props.currentStep === 2){
      mensajeExito("La solicitud se envió correctamente")
    }
    return (
      <div>
        <div className="row">
          <div className="steps step-doc clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-8" style={{ textAlign: "end" }}>
            <p className="nro-operacion">
              Número de Subsidio: {this.props.respuestasData.nroSubsidio}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <DatosSocio />
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-8">
            <div className="inner" style={{ paddingTop: 2, paddingBottom: 1 }}>
              <p style={{ margin: 0 }}>
                Tipo: {mayusculaPrimeraLetra(this.props.respuestasData.datosSubsidio.tipoSubsidio)}
              </p>
              <p style={{ margin: 1 }}>
                Clase: {mayusculaPrimeraLetra(this.props.respuestasData.datosSubsidio.claseSubsidio)}
              </p>
              <hr/>
                <h6 style={{ marginTop: '8px', fontSize: '1.1rem' }}>
                  Archivos Enviados: {this.props.respuestasData.cantidadArchivos}
                </h6>
                <hr/>
            </div>
          </div>
        </div>

        <br />

        <div className="row">
          <div className="col-md-10">
            <div className="col-6 float-left">
              <button
                hidden
                className="btn btn-cu-secundary"
                style={{ marginRight: "5px" }}
                onClick={this.VolverSubsidios}
              >
                Volver al Listado
              </button>
            </div>
          </div>
          <div className="col-md-2">
            <div className="row float-right">
              <button
                className="btn btn-cu-secundary"
                style={{ marginRight: "5px" }}
                onClick={this.VolverSubsidios}
              >
                Volver al Listado
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}